import React from 'react'
import { Formulario } from '../Formulario/Formulario'

export const TrabajaConNosotros = () => {
  return <Formulario />
}
